// const childrenRouter = [
//   {
//     path: 'projectList',
//     name: 'ProjectList',
//     component: () => import('@/views/projects/index'),
//     meta: {
//       title: '案件一覧',
//     },
//   },
//   {
//     path: 'constructionrecordbook',
//     name: 'Constructionrecordbook',
//     meta: {
//       title: '工事記録簿',
//     },
//     children: [
//       {
//         path: 'list',
//         name: 'ConstructionrecordbookList',
//         component: () => import('@/views/undevelop'),
//         meta: {
//           title: '工事記録簿一覧',
//         },
//       },
//       {
//         path: 'approvalList',
//         name: 'ConstructionrecordbookApprovalList',
//         component: () => import('@/views/undevelop'),
//         meta: {
//           title: '工事記録簿承認待ち一覧',
//         },
//       },
//     ],
//   },
//   {
//     path: 'proposalplan',
//     name: 'Proposalplan',
//     meta: {
//       title: '提案計画',
//     },
//     children: [
//       {
//         path: 'list',
//         name: 'ProposalplanList',
//         component: () => import('@/views/undevelop'),
//         meta: {
//           title: '提案計画一覧',
//         },
//       },
//       {
//         path: 'quotationlist',
//         name: 'Quotationlist',
//         component: () => import('@/views/undevelop'),
//         meta: {
//           title: '課題・見積依頼一覧',
//         },
//       },
//     ],
//   },
//   {
//     path: 'mitsumori',
//     name: 'Mitsumori',
//     meta: {
//       title: '見積',
//     },
//     children: [
//       {
//         path: 'list',
//         name: 'Estimatelist',
//         component: () => import('@/views/undevelop'),
//         meta: {
//           title: '見積一覧',
//         },
//       },
//       {
//         path: 'costsApprovalList',
//         name: 'CostsApprovalList',
//         component: () => import('@/views/undevelop'),
//         meta: {
//           title: '原価・見積承認待ち一覧',
//         },
//       },
//       {
//         path: 'unitpriceList',
//         name: 'UnitpriceList',
//         component: () => import('@/views/undevelop'),
//         meta: {
//           title: '見積単価一覧',
//         },
//       },
//       {
//         path: 'estCompany',
//         name: 'EstCompany',
//         component: () => import('@/views/undevelop'),
//         meta: {
//           title: '見積協力会社一覧',
//         },
//       },
//     ],
//   },
// ]

// export default childrenRouter
